exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer[data-v-7e388f56]{display:table;width:100%;height:100%}.outer .inner[data-v-7e388f56]{padding:10px;display:table-cell;vertical-align:middle;text-align:center;font-family:Delius,serif;font-size:18px;line-height:20px;padding:0;border-radius:8px 8px 8px 8px;-moz-border-radius:8px 8px 8px 8px;-webkit-border-radius:8px 8px 8px 8px;border:3px solid hsla(0,7%,5%,.89)}.outer .inner span[data-v-7e388f56]{margin:2px 0 0 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e388f56","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/WidgetDropdown.vue
// module id = 82
// module chunks = 0